export const NOTE_MODEL = {
  NFE: '55',
  NFCE: '65',
}
